import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480 u-form-grid-nospace-y" }
const _hoisted_2 = {
  key: 0,
  class: "u-form-heading unset-text-align"
}
const _hoisted_3 = { class: "c-form-control-checkbox" }
const _hoisted_4 = ["onUpdate:modelValue", "id", "disabled", "onChange"]
const _hoisted_5 = ["for"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "gev19-optional-module-content" }
const _hoisted_11 = {
  key: 0,
  class: "gev19-optional-module-content-icon"
}
const _hoisted_12 = {
  key: 1,
  class: "gev19-optional-module-content-text u-mar-t-1"
}
const _hoisted_13 = {
  key: 1,
  class: "zuerstext"
}
const _hoisted_14 = { class: "c-list" }
const _hoisted_15 = { class: "c-list__item" }
const _hoisted_16 = {
  key: 2,
  class: "gev19-optional-module-content-text"
}
const _hoisted_17 = {
  key: 3,
  class: "gev19-optional-module-content-text"
}
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  key: 1,
  class: "zuerstext"
}
const _hoisted_20 = { class: "c-list" }
const _hoisted_21 = { class: "c-list__item" }
const _hoisted_22 = { class: "gev19-optional-module-premium u-text-align-right" }
const _hoisted_23 = ["onClick", "innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_sprite = _resolveComponent("icon-sprite")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.produktmodule, (modul) => {
    return (_openBlock(), _createElementBlock("div", {
      key: modul.modulId
    }, [
      (modul.anzeigen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["o-grid", {
        'u-mar-t-1': modul.modulPrefix === '',
        'u-mar-t-2': modul.modulPrefix !== '',
      }])
          }, [
            _createElementVNode("div", _hoisted_1, [
              (modul.modulPrefix !== '')
                ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(modul.modulPrefix), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200", {
          'u-form-grid-nospace-y': modul.modulPrefix === '',
          'u-form-grid-lowspace-y': modul.modulPrefix !== '',
        }])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["gev19-optional-module", {
            'gev19-optional-module--enabled': _ctx.piniaStore.state.tarifinformationen[modul.modulId],
            'gev19-optional-module--disabled': modul.aktiv === false,
          }])
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_3, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((_ctx.piniaStore.state.tarifinformationen[modul.modulId]) = $event),
                      id: modul.modulId,
                      class: "c-form-control-checkbox__input",
                      type: "checkbox",
                      tabindex: "0",
                      disabled: !modul.aktiv,
                      onChange: ($event: any) => (_ctx.emitChange(modul.modulId, _ctx.piniaStore.state.tarifinformationen[modul.modulId]))
                    }, null, 40, _hoisted_4), [
                      [_vModelCheckbox, _ctx.piniaStore.state.tarifinformationen[modul.modulId]]
                    ]),
                    _createElementVNode("label", {
                      for: modul.modulId,
                      class: "c-form-control-checkbox__label"
                    }, [
                      _createVNode(_component_icon_sprite, {
                        "icon-name": "icon-check-mark",
                        "css-klassen": "c-form-control-checkbox__icon",
                        "ist-klein": true
                      }),
                      (!_ctx.piniaStore.state.isMakler)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "c-form-control-checkbox__label-text",
                            innerHTML: modul.name
                          }, null, 8, _hoisted_6))
                        : _createCommentVNode("", true),
                      (_ctx.piniaStore.state.isMakler)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: "c-form-control-checkbox__label-text",
                            innerHTML: modul.nameMakler
                          }, null, 8, _hoisted_7))
                        : _createCommentVNode("", true),
                      (!modul.aktiv)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 2,
                            innerHTML: modul.inaktivText,
                            class: "gev19-optional-module-content__inactive-text"
                          }, null, 8, _hoisted_8))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_5),
                    (modul.info.length)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "gev19__contexthelp-open",
                          title: "Hilfe anzeigen",
                          onClick: ($event: any) => (_ctx.zeigeInfo(modul))
                        }, null, 8, _hoisted_9))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    (modul.icon.length && _ctx.zeigeIcons)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createVNode(_component_icon_sprite, {
                            "icon-name": modul.icon,
                            "ist-gross": true
                          }, null, 8, ["icon-name"])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.istFhkVerkaufsprodukt(_ctx.piniaStore.state) && _ctx.zeigeElementarHinweis(modul))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _renderSlot(_ctx.$slots, "vhvElementarHinweis", {}, undefined, true),
                          (_ctx.zuersZoneUnbekannt(modul))
                            ? _renderSlot(_ctx.$slots, "unbekannteZuersZoneHinweis", { key: 0 }, undefined, true)
                            : _createCommentVNode("", true),
                          (_ctx.zeigeZuersZone(modul))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createElementVNode("ul", _hoisted_14, [
                                  _createElementVNode("li", _hoisted_15, [
                                    _cache[0] || (_cache[0] = _createElementVNode("strong", null, "Ermittelte Zonen: ", -1)),
                                    _createTextVNode(_toDisplayString(_ctx.piniaStore.state.zuersZone.zone) + " ZÜRS, " + _toDisplayString(_ctx.piniaStore.state.zuersZone.starkregen) + " Starkregen ", 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.istFhkVerkaufsprodukt(_ctx.piniaStore.state) && _ctx.zeigeElementarHinweis(modul))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _renderSlot(_ctx.$slots, "vhvElementarHinweis", {}, undefined, true)
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.zeigeElementarHinweis(modul))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("span", {
                            innerHTML: modul.body
                          }, null, 8, _hoisted_18),
                          (_ctx.zuersZoneUnbekannt(modul))
                            ? _renderSlot(_ctx.$slots, "unbekannteZuersZoneHinweis", { key: 0 }, undefined, true)
                            : _createCommentVNode("", true),
                          (_ctx.zeigeZuersZone(modul))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createElementVNode("ul", _hoisted_20, [
                                  _createElementVNode("li", _hoisted_21, [
                                    _cache[1] || (_cache[1] = _createElementVNode("strong", null, "Ermittelte Zonen: ", -1)),
                                    _createTextVNode(_toDisplayString(_ctx.piniaStore.state.zuersZone.zone) + " ZÜRS, " + _toDisplayString(_ctx.piniaStore.state.zuersZone.starkregen) + " Starkregen ", 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (modul.modulId === 'fahrradschutz')
                    ? _renderSlot(_ctx.$slots, "vhvFahrrad", { key: 0 }, undefined, true)
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_22, _toDisplayString(modul.preisId ? _ctx.formatCurrency(_ctx.calculateIndex(modul.preisId)) : "beitragspflichtig"), 1),
                  (modul.modulId === 'elementar' && _ctx.piniaStore.state.tarifinformationen.elementar)
                    ? _renderSlot(_ctx.$slots, "vhvElementar", { key: 1 }, undefined, true)
                    : _createCommentVNode("", true)
                ]),
                (modul.show)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "gev19__contexthelp-text",
                      onClick: ($event: any) => (_ctx.zeigeInfo(modul)),
                      innerHTML: _ctx.infoText(modul)
                    }, null, 8, _hoisted_23))
                  : _createCommentVNode("", true)
              ], 2)
            ], 2)
          ], 2))
        : _createCommentVNode("", true)
    ]))
  }), 128))
}